import { ContentChild, Directive, HostListener } from '@angular/core';
import { ContextMenuComponent } from './context-menu/context-menu.component';

@Directive({
    selector: '[appListViewItem]',
    standalone: false
})
export class ListViewItem {
  constructor() {}

  @ContentChild(ContextMenuComponent) menu: ContextMenuComponent;

  @HostListener('mouseenter') onMouseEnter() {
    if (this.menu) {
      this.menu.buttonVisible = true;
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.menu) {
      this.menu.buttonVisible = false;
    }
  }
}
